// Mock data for Miwrite Match Landing Page

export const pricingData = [
  {
    category: "IT・BtoB領域",
    priceRange: "20,000〜30,000円",
    examples: "ITコンサル、マーケター"
  },
  {
    category: "不動産・住宅",
    priceRange: "25,000〜35,000円",
    examples: "宅建士、建築士"
  },
  {
    category: "金融・保険",
    priceRange: "30,000〜40,000円",
    examples: "FP、CFP"
  },
  {
    category: "医療・ヘルスケア",
    priceRange: "35,000〜50,000円",
    examples: "医師、医療従事者"
  },
  {
    category: "法律・士業",
    priceRange: "35,000〜50,000円",
    examples: "弁護士、社労士"
  },
  {
    category: "生活・専門ニッチ",
    priceRange: "20,000〜30,000円",
    examples: "専門資格保有者"
  }
];

export const processSteps = [
  {
    step: 1,
    title: "お問い合わせ",
    description: "フォームからお問い合わせください",
    hasLink: true
  },
  {
    step: 2,
    title: "打ち合わせ",
    description: "状況確認・論点整理"
  },
  {
    step: 3,
    title: "監修者アサイン",
    description: "最短即日"
  },
  {
    step: 4,
    title: "監修者チェック・納品",
    description: "専門家が記事を確認"
  },
  {
    step: 5,
    title: "監修者情報を掲載",
    description: "プロフィール等を記載"
  },
  {
    step: 6,
    title: "請求",
    description: "月末締め翌月末払い"
  }
];

export const features = [
  {
    title: "分野横断で対応できる一元窓口",
    description: "500名以上の監修者候補から、テーマに最適な人材を選定"
  },
  {
    title: "24時間以内のレスを徹底したディレクション",
    description: "やり取り・期限管理・修正整理までディレクションを代行"
  },
  {
    title: "最短即日アサインでスケジュールを守れる",
    description: "最短即日で監修をスタート"
  },
  {
    title: "固定費なし、1記事から依頼できる料金設計",
    description: "月額・初期費用0円、1記事単位で依頼可能"
  },
  {
    title: "3000名以上のライター・編集者ネットワークも活用できる",
    description: "記事監修マッチのネットワークを活用してライティング、リライト、校正校閲、入稿、取材、企画、イラストなど他業務も依頼可能"
  },
  {
    title: "スタッフによる徹底サポート",
    description: "記事監修マッチのネットワーク外でも代わりに探してご提案するため、「監修者を探し回る」ことはもう不要です"
  }
];

// 記事監修者一覧
export const supervisors = [
  {
    id: 1,
    nameEn: "Fujita",
    photo: "/images/assets/viki290b-9D899B0B-3109-4708-8683-440FDE475635.png",
    field: "不動産",
    title: "宅地建物取引士",
    credentials: "",
    description: "大手不動産デベロッパーで運営管理・リーシング・契約業務に10年以上従事。1,500本以上の記事執筆経験も活かし、大手不動産ポータルサイトの記事監修も手がける。"
  },
  {
    id: 2,
    nameEn: "Shigeno",
    photo: "/images/assets/kluqpx3b-46652891-0FB7-4CDE-B4EA-76FC6D6B008E.png",
    field: "金融",
    title: "1級FP技能士",
    credentials: "CFP認定者",
    description: "マネーハックFP事務所代表。金融機関での実務経験に加え、投資スクールにおける講師実績も。多様な視点から課題を分析・評価する能力に定評があり、金融メディアの監修を手掛ける。"
  },
  {
    id: 3,
    nameEn: "Oka",
    photo: "/images/assets/9uu08bl8-1FF668D8-C34D-4329-B8A0-DD65BD2FBB08.png",
    field: "IT・BtoB",
    title: "SEOスペシャリスト",
    credentials: "FP2級",
    description: "外資系企業の現役SEOスペシャリスト。著書『AI時代のコンテンツSEOの教科書』やUdemy講座など、最新アルゴリズムへの対策指導に定評あり。E-E-A-Tを最大化する記事監修を行う。"
  },
  {
    id: 4,
    nameEn: "Miyamoto",
    photo: "/images/assets/hmjfa5wm-9A6E7324-6BB0-44F3-8FAB-F996B2E5013D.png",
    field: "医療",
    title: "薬剤師",
    credentials: "",
    description: "臨床・研究・教育の3分野を経験。医薬品・サプリ・美容医療・商品紹介と幅広く監修を行う。商業出版3冊の経験から科学的根拠を踏まえた分かりやすい監修を心がけている。"
  },
  {
    id: 5,
    nameEn: "Matsuda",
    photo: "/images/assets/e558t7te-EA7BDAA6-F8C6-4819-82BD-FEE1749AD6C5.png",
    field: "法律",
    title: "弁護士",
    credentials: "弁理士",
    description: "弁護士として16年以上、相続・不動産等の個人案件から企業案件まで幅広く担当。弁理士として商標申請や著作権のトラブルにも対応。関西学院大学商学部での講師経験も。"
  }
];
